import { ButtonStyle, ModalActionTypes } from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'

import { trackRegistrationCreateAccountVerifyEmailModalViewedPayload } from 'generated/trackingEvents'
import { translateEventProps } from 'utils/analytics'
import trackEvent from 'utils/analytics/trackEvent'
import { PromptConfig } from 'utils/prompts'

interface Strings {
  title: string
  description: string
  primaryLabel: string
  secondaryLabel: string
}

interface VerifyEmailInput {
  analytics: ReturnType<typeof useAnalyticsClient>
  handleChange: () => void
  handleOk: () => void
  strings: Strings
  getSourceAttributes: () => Record<any, any>
}

export const VerifyEmailModal = ({
  analytics,
  handleChange,
  handleOk,
  strings,
  getSourceAttributes,
}: VerifyEmailInput): PromptConfig => {
  const handlePrimaryCTAClick = () => {
    trackEvent('Button Tapped', {
      eventData: translateEventProps(
        {
          object_name: 'createAccountVerifyEmailModalVerifyCTA',
          screen: 'createAccountVerifyEmailModalVerifyCTA',
          screen_name: 'createAccountVerifyEmailModalVerifyCTA',
          feature: 'createAccountVerifyEmailModalVerifyCTA',
          event_description: 'Button Tapped',
          object: 'Button',
          action: 'Tapped',
        },
        getSourceAttributes,
      ),
    })
    handleOk()
  }
  const [eventName, payload] = trackRegistrationCreateAccountVerifyEmailModalViewedPayload({
    tier: undefined,
    funnel: undefined,
  })
  analytics.track(eventName, translateEventProps(payload, getSourceAttributes))
  return {
    actions: [
      {
        type: ModalActionTypes.secondary,
        label: strings.secondaryLabel,
        handler: handleChange,
      },
      {
        type: ModalActionTypes.primary,
        label: strings.primaryLabel,
        handler: handlePrimaryCTAClick,
      },
    ],
    buttonStyle: ButtonStyle.row,
    image: null,
    title: strings.title,
    message: strings.description,
    closeModalCallback: handleChange,
  }
}
